/**
 * @param {any} string
 * @param {number} length
 * @returns {string}
 */
const truncate = (string, length) => {
  if (string == null) return '';
  const str = String(string);
  return str.length > length ? str.slice(0, length) + '...' : str;
}

export default truncate;